import * as React from "react"

export const RouterContext = React.createContext()
